export const BINGO_FTUE_STORAGE_KEY = (firebaseUid: string) => `bingo_ftue_step:${firebaseUid}`;
